export const chartColors = [
  "var(--primary)",
  "var(--primary-20)",
  "var(--primary-30)",
  "var(--primary-40)",
  "var(--primary-50)",
  "var(--primary-60)",
  "var(--primary-70)",
  "var(--secondary)",
  "var(--secondary-20)",
  "var(--secondary-30)",
  "var(--secondary-40)",
  "var(--secondary-50)",
  "var(--secondary-60)",
  "var(--secondary-70)",
];